// src/redux/empattendanceSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_emp_attendance,
  add_emp_attendance,
  update_emp_attendance,
  delete_emp_attendance,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  empattendance: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:"",

  },
};



// Async Thunks for API Calls
export const fetchempattendance = createAsyncThunk(
  "empattendance/fetchempattendance",
  async ({ page, page_size,search,school_id,formdata, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_emp_attendance(page, page_size,search,school_id,formdata,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createempattendance = createAsyncThunk(
  "empattendance/createempattendance",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_emp_attendance(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateempattendance = createAsyncThunk(
  "empattendance/updateempattendance",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_emp_attendance(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteempattendance = createAsyncThunk(
  "empattendance/deleteempattendance",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_emp_attendance({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// empattendance Slice
const empattendanceSlice = createSlice({
  name: 'empattendances',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, title,bank_name,account_no,ifsc,balance} = action.payload;
      state.formData = { id, title,bank_name,account_no,ifsc,balance};
    },
    resetFormData(state) {
      state.formData = {
       title:"",
    bank_name:"",
    account_no:"",
    ifsc:"",
    balance:0,
      };
    },
    setempattendance(state, action) {
      state.empattendance = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
         // Fetch empattendance
       .addCase(fetchempattendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchempattendance.fulfilled, (state, action) => {
        state.loading = false;
        state.empattendance = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchempattendance.rejected, (state, action) => {
        state.loading = false;
        state.empattendance = [];
        state.error = action.payload;
      })

      // Add empattendance
      .addCase(createempattendance.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createempattendance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createempattendance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update empattendance
      .addCase(updateempattendance.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateempattendance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateempattendance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete empattendance
      .addCase(deleteempattendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteempattendance.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteempattendance.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.data?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setempattendance,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = empattendanceSlice.actions;
export default empattendanceSlice.reducer;
